import axios from 'axios';

const BASE_URL_FUNNEL = '/app/emailConfirmFunnel';
const BASE_URL_EMAIL_FUNNEL = '/app/emailFunnel';

export const createConfirmationEmail = async (emailTitle) => {
    const { data } = await axios.post(`${BASE_URL_FUNNEL}/initialized-template`, emailTitle, {
        headers: {
            'Content-Type': 'text/html',
        },
    });

    return data;
};

export const updateConfirmationEmail = async (marketingEmailId, payload) => {
    await axios.put(`${BASE_URL_FUNNEL}/${marketingEmailId}`, payload, {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        },
    });
};

export const syncEmailConfirmationLabel = async (cell) => {
    const marketingEmailId = cell.value?.marketingEmailId ?? 0;
    const newName = cell.value?.name ?? '';

    if (marketingEmailId && newName) {
        await axios.put(`${BASE_URL_EMAIL_FUNNEL}/${marketingEmailId}/name`, newName, {
            headers: {
                'Content-Type': 'text/html',
            },
        });
    }
};
